import { useTranslation } from "react-i18next";
import clsx from "clsx";

import type { IAppointmentDataCardButtonProps } from "@components/organisms/appointmentCard/components/appointmentCardButtons/types";
import classes from "@components/organisms/appointmentCard/components/appointmentCardButtons/styles.module.scss";
import { Button } from "@components/atoms/button";
import { path } from "@/routes/path";
import type {
  IAppointmentCardVariants,
  IAppointmentDataVariants,
  IMspVariants,
} from "@components/organisms/appointmentCard/components/appointmentCardBottom";
import type { IAppointmentDataType } from "@api/appointmentData";
import type { ID } from "@constants";

export function AppointmentDataCardButtons({
  type,
  id,
  summaryNoteId,
}: IAppointmentDataCardButtonProps) {
  const { t } = useTranslation("common");

  const msp: IAppointmentCardVariants[] = [
    "msp_prescription",
    "msp_image",
    "msp_order",
  ];

  const isMsp = msp?.includes(type);

  return (
    <div className={clsx(classes.appointmentButtons)}>
      {
        <Button
          mode={"main"}
          label={t(`show_${type}`)}
          linkTo={getLink(type, isMsp, id, summaryNoteId)}
        />
      }
    </div>
  );
}

const getLink = (
  variant: IAppointmentDataVariants | IMspVariants,
  isMsp: boolean,
  id: ID,
  summaryNoteId: ID,
) => {
  if (isMsp) {
    if (variant === "msp_prescription") {
      return path.msp.prescriptionView.link(summaryNoteId, id);
    }
    if (variant === "msp_image") {
      return path.msp.imagesView.link(summaryNoteId, id);
    }
    if (variant === "msp_order") {
      return path.msp.experimentsView.link(summaryNoteId, id);
    }
  } else {
    return path.healthRecord.view.link(variant as IAppointmentDataType, id);
  }
};
